
/* 94 DOMES - hover carousel: cycle all product angles on card hover */
(function(){
  var CACHE = {};
  var INTERVAL_MS = 750;

  function sized(url, w){
    if(!url) return url;
    if(url.indexOf('//')===0) url='https:'+url;
    return url + (url.indexOf('?')>-1 ? '&' : '?') + 'width=' + w;
  }
  function handleFromCard(card){
    var a = card.querySelector('a[href*="/products/"]');
    if(!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function fetchImages(handle){
    if(CACHE[handle]) return Promise.resolve(CACHE[handle]);
    return fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(p){
        var imgs = (p.images||[]).map(function(u){return sized(u,700);});
        CACHE[handle]=imgs; return imgs;
      }).catch(function(){return [];});
  }
  function ensureOverlay(mediaEl){
    var ov = mediaEl.querySelector('.dome-hover-cycle');
    if(ov) return ov;
    if(getComputedStyle(mediaEl).position==='static') mediaEl.style.position='relative';
    ov=document.createElement('img');
    ov.className='dome-hover-cycle';
    ov.setAttribute('aria-hidden','true');
    ov.style.cssText='position:absolute;inset:0;width:100%;height:100%;object-fit:contain;'
      +'background:#fff;opacity:0;transition:opacity .15s ease;pointer-events:none;z-index:3;';
    mediaEl.appendChild(ov);
    return ov;
  }
  function bind(card){
    if(card.__domeBound) return; card.__domeBound=true;
    var media = card.querySelector('.card__media') || card.querySelector('.card__inner') || card;
    var handle = handleFromCard(card);
    if(!handle || !media) return;
    var ov=ensureOverlay(media);
    var timer=null, idx=0, imgs=[];
    function start(){
      fetchImages(handle).then(function(list){
        imgs=list; if(imgs.length<2) return;
        idx=0; ov.src=imgs[0]; ov.style.opacity='1';
        clearInterval(timer);
        timer=setInterval(function(){
          idx=(idx+1)%imgs.length; ov.src=imgs[idx];
        },INTERVAL_MS);
      });
    }
    function stop(){ clearInterval(timer); timer=null; ov.style.opacity='0'; idx=0; }
    card.addEventListener('mouseenter',start);
    card.addEventListener('mouseleave',stop);
    card.addEventListener('focusin',start);
    card.addEventListener('focusout',stop);
  }
  function scan(){
    document.querySelectorAll('.card-wrapper, .card').forEach(function(c){
      if(c.querySelector('a[href*="/products/"]')) bind(c);
    });
  }
  if(document.readyState!=='loading') scan();
  else document.addEventListener('DOMContentLoaded',scan);
  document.addEventListener('shopify:section:load',scan);
})();
